// extracted by mini-css-extract-plugin
export default {"xxxs":"6px","xxs":"8px","xs":"12px","s":"16px","m":"24px","l":"32px","xl":"48px","root":"style_root__8Coy7"};